import Figure from "~/components/figure"
import { find, random } from "lodash"
import { Badge } from "evergreen-ui"

const center = 0
const contrast = 1
const shape = 2
const texture = 3
const gradient = 4

const ZoomedImg = ({ src, size, padding, style, ...props }) => (
  <div
    style={Object.assign({}, style, {
      width: size,
      borderRadius: 5,
      height: size,
      overflow: "hidden",
      position: "relative",
    })}
    {...props}
  >
    <img
      src={src}
      width={size + padding * 2}
      height={size + padding * 2}
      style={{ position: "absolute", left: -padding, top: -padding }}
    />
  </div>
)

const layers = [
  {
    layer: "conv2d1",
    groups: [
      { name: "color contrast", type: contrast, count: 9, neuron: 2 },
      { name: "multicolor", type: texture, count: 7, neuron: 48 },
      { name: "low freq", type: texture, count: 10, neuron: 1 },
      // { name: "gabor", type: shape, count: 9, neuron: 30 },
      { name: "low freq gabor", type: shape, count: 1, neuron: 28 },
      { name: "color", type: texture, count: 2, neuron: 36 },
      { name: "hatch", type: texture, count: 1, neuron: 14 },
    ],
  },
  {
    layer: "conv2d2",
    groups: [
      { name: "color constrast", type: contrast, count: 27, neuron: 10 },
      { name: "other edge", type: shape, count: 36, neuron: 8 },
      { name: "edge", type: shape, count: 11, neuron: 3 },
      { name: "gabor like", type: shape, count: 11, neuron: 89 },
      { name: "proto brightness", type: texture, count: 12, neuron: 94 },
      { name: "color center", type: center, count: 12, neuron: 155 },
      { name: "curves", type: shape, count: 9, neuron: 182 },
      { name: "proto high-low", type: contrast, count: 8, neuron: 1 },
      { name: "hatch", type: texture, count: 4, neuron: 164 },
      // { name: "edge curve", type: shape, count: 3, neuron: 140 },
      { name: "divergence", type: center, count: 2, neuron: 137 },
    ],
  },
  {
    layer: "mixed3a",
    groups: [
      { name: "curve", type: shape, count: 10, neuron: 104 },
      { name: "color contrast", type: contrast, count: 13, neuron: 195 },
      // { name: "black and white", type: texture, count: 9, neuron: 222 },
      { name: "line", type: shape, count: 6, neuron: 134 },
      { name: "line grad", type: gradient, count: 8, neuron: 151 },
      { name: "line misc", type: shape, count: 23, neuron: 173 },
      { name: "center surround", type: center, count: 30, neuron: 119 },
      // { name: "texture", type: texture, count: 30, neuron: 246 },
      { name: "high low", type: contrast, count: 15, neuron: 110 },
      { name: "gradient", type: gradient, count: 15, neuron: 206 },
      { name: "pattern", type: texture, count: 11, neuron: 237 },
      { name: "complex center", type: center, count: 14, neuron: 178 },
      { name: "fur", type: texture, count: 7, neuron: 46 },
      {
        name: "texture gradient",
        type: gradient,
        count: 10,
        neuron: 229,
      },
      { name: "triangle", type: shape, count: 8, neuron: 188 },
      { name: "edge pattern", type: texture, count: 8, neuron: 227 },
      { name: "eyes", type: center, count: 5, neuron: 174 },
      { name: "thick line", type: shape, count: 3, neuron: 140 },
    ],
  },
]

export default class EarlyVisionBanner extends Component {
  render() {
    const groups = {
      shape,
      center,
      contrast,
      gradient,
      texture,
    }

    const neuronGroups = (layer, groupName) => {
      return find(layers, obj => obj.layer === layer).groups.filter(
        ({ type }) => type === groups[groupName],
      )
    }

    const groupNames = Object.keys(groups)
    const cellWidth = 300
    const cellHeight = 280
    const pad = 0
    const labelWidth = 140
    const rowWidth = 1600

    return (
      <Figure>
        <Surface>
          <Surface
            flexFlow="row"
            width={rowWidth}
            height={40}
            justifyContent="center"
          >
            <Surface margin={pad} width={labelWidth} />
            {groupNames.map(groupName => (
              <Surface margin={pad} width={cellWidth}>
                <Text textAlign="center" fontWeight={600}>
                  {groupName}
                </Text>
              </Surface>
            ))}
          </Surface>
          {layers.map(({ layer }) => (
            <Surface flexFlow="row" width={rowWidth}>
              <Surface margin={pad} width={labelWidth} alignSelf="center">
                <Text textAlign="center" fontWeight={600}>
                  {layer}
                </Text>
              </Surface>
              {groupNames.map(groupName => (
                <Surface
                  flexFlow="row"
                  flexWrap="wrap"
                  border
                  width={cellWidth}
                  height={cellHeight}
                  alignItems="center"
                  justifyContent="center"
                  alignContent="center"
                >
                  {neuronGroups(layer, groupName).map(
                    ({ name, neuron, count }) => (
                      <Surface alignItems="center" margin={10}>
                        <ZoomedImg
                          padding={20}
                          size={70}
                          src={neuronFeatureVis("inceptionv1", layer, neuron)}
                        />
                        <Surface
                          flexFlow="row"
                          alignItems="center"
                          marginTop={5}
                        >
                          <Text marginX={5} size={400}>
                            {name}
                          </Text>
                          <Badge>{count}</Badge>
                        </Surface>
                      </Surface>
                    ),
                  )}
                </Surface>
              ))}
            </Surface>
          ))}
        </Surface>
      </Figure>
    )
  }
}
